export default __webpack_public_path__ + "static/media/kcc-logo.d9909f20.svg";